import * as React from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  SELECTED_ELEMENT,
  USE_SELECTED_INDEX,
} from "../../../hooks/useSelectedElement";
import { XGUIProps } from "../../../utils/interfaces/gui/fields.interfaces";
import { createPopper, Instance as PopperInstance } from "@popperjs/core";
import XGUIContainer from "../components/XGUIContainer";

import { Stack } from "@mui/material";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { XGUIActions } from "./XGUIActions";
import { XGUIHeader, X_PAGE_SETTINGS } from "./XGUIHeader";
import { XGUIFieldContainer } from "./XGUIFieldContainer";

const XGUI: React.FC<XGUIProps> = () => {
  // THIS IS THE CURRENT SELECTED ELEMENT
  const [selectedElement, setSelectedElement] =
    useRecoilState(SELECTED_ELEMENT);

  const [popper, setPopper] = React.useState<PopperInstance>();

  // THIS IS USE TO CLOSE THE POPUP
  const setSelectedIndex = useSetRecoilState(USE_SELECTED_INDEX);

  const breakpoint = useBreakpoint();

  // THE CURRENT ELEMENT REF TO USE WITH POPPER.JS
  const guiRef = React.useRef<any>();

  // INIT THE POPPER IF ALL DATA ARE OK
  React.useEffect(() => {
    if (!guiRef.current) return;

    if (selectedElement) {
      if (!selectedElement.index) return setSelectedIndex(null);

      const element = document.getElementById(selectedElement.index);

      if (!element) return setSelectedIndex(null);

      const browserHeader = document.querySelector("#XEditor");

      if (!browserHeader) return setSelectedIndex(null);

      setPopper(
        createPopper(element, guiRef.current, {
          placement: "top-start",
          strategy: "fixed",
          modifiers: [
            {
              name: "myModifier",
              enabled: true,
              phase: "main",
              requiresIfExists: ["offset"],
              options: {
                boundary: browserHeader,
              },
              fn(/*{ state }*/) {
                // const overflow = detectOverflow(state);
                // const browserTop =
                //   (browserHeader as HTMLDivElement).offsetTop +
                //   // BROWER_HEADER HEIGHT
                //   50;
                // if (state.rects.reference.y <= browserTop - 10) {
                //   console.log(
                //     "overflow",
                //     overflow,
                //     state.rects.reference.y,
                //     browserTop - 10
                //   );
                //   // setSelectedIndex(null);
                // }
                // ...
              },
            },
            {
              name: "offset",
              options: {
                offset: ({ reference, placement }: any) => {
                  if (placement === "top-start") {
                    return [0, -reference.height];
                  } else {
                    return [0, 0];
                  }
                },
              },
            },
            {
              name: "preventOverflow",
              options: {
                boundary: document.getElementById("XPage"),
              },
            },
            {
              name: "flip",
              enabled: false,

              options: {
                flipVariations: false, // true by default
                // boundary: document.getElementById("XPage"),
              },
            },
            // {
            //   name: "flip",
            //   options: {
            //     fallbackPlacements: ["top-start"],
            //   },
            // },
            {
              name: "sameWidth",
              enabled: true,
              fn: ({ state }) => {
                state.styles.popper.width = `${state.rects.reference.width}px`;
                state.styles.popper.height = `${state.rects.reference.height}px`;
              },
              phase: "beforeWrite",
              requires: ["computeStyles"],
            },
          ],
        })
      );
    }
    // else {
    //   const pageElement = document.getElementById("X_BROWSER");

    //   if (!pageElement) return;

    //   setPopper(
    //     createPopper(pageElement, guiRef.current, {
    //       placement: "right-start",
    //       strategy: "fixed",
    //       modifiers: [
    //         {
    //           name: "offset",
    //           options: {
    //             offset: [0, 15],
    //           },
    //         },
    //       ],
    //     })
    //   );
    // }

    if (typeof popper !== "undefined") return popper.destroy;
  }, [selectedElement, guiRef.current, breakpoint]);

  return (
    <>
      {
        <Stack
          id="popper"
          data-popper-reference-hidden={true}
          ref={guiRef}
          sx={{ pointerEvents: "none", opacity: selectedElement ? 1 : 0 }}
          border={2}
          borderColor="secondary.main"
          justifyContent="flex-end"
          position="absolute"
          zIndex={100}
        >
          <XGUIActions
            selectedElement={selectedElement ?? X_PAGE_SETTINGS}
            setSelectedIndex={setSelectedIndex}
          />
        </Stack>
      }
      <Stack
        sx={{
          width: 400,
          position: "relative",
          // zIndex: 100,
          // transition: "all linear 0.3s",
        }}
      >
        <XGUIContainer className="XGUI-Container">
          <XGUIHeader
            selectedElement={selectedElement ?? X_PAGE_SETTINGS}
            setSelectedIndex={setSelectedIndex}
          />
          <XGUIFieldContainer
            selectedElement={selectedElement ?? X_PAGE_SETTINGS}
            setSelectedElement={setSelectedElement}
          />
        </XGUIContainer>
      </Stack>
    </>
  );
};

export default XGUI;
